import { formatPreboreValue, getLocationFromHole, getPreboreFromHole } from 'Utils/prebore'

export type { PreboreFields } from 'Utils/prebore'
export { formatPreboreCell } from 'Utils/prebore'

export interface PileHoleTableRow {
  id: number
  seq: number
  status: string
  poleCodes: string[]
  preboreDepth: number | null
  preboreDrillSize: number | null
  pileNo: string | null
  gridLine: string | null
  location: string | null
}

export type PileHoleStatusFilter =
  | 'all'
  | 'in-progress'
  | 'completed'
  | 'repairing'
  | 'change-pile'

export const PILE_HOLE_STATUS_LABELS: Record<string, string> = {
  'in-progress': 'กำลังดำเนินการ',
  completed: 'เสร็จสิ้น',
  repairing: 'เสียหาย - ซ่อมแซม',
  'change-pile': 'เสียหาย - เปลี่ยน',
}

export const PILE_HOLE_STATUS_BADGE: Record<string, string> = {
  'in-progress': 'badge-info',
  completed: 'badge-success',
  repairing: 'badge-danger',
  'change-pile': 'badge-danger',
}

export function mapPileHolesToTableRows(pileHoles: any[]): PileHoleTableRow[] {
  return pileHoles.map(hole => {
    const prebore = getPreboreFromHole(hole)
    const locationFields = getLocationFromHole(hole)
    const itemInventory = hole.itemInventory ?? []
    return {
      id: hole.id,
      seq: hole.seq,
      status: hole.status ?? '',
      poleCodes: itemInventory.map((item: any) => item.pileCode).filter(Boolean),
      preboreDepth: prebore.preboreDepth,
      preboreDrillSize: prebore.preboreDrillSize,
      pileNo: locationFields.pileNo,
      gridLine: locationFields.gridLine,
      location: locationFields.location,
    }
  })
}

export function computePileHoleSummary(rows: PileHoleTableRow[]) {
  const total = rows.length
  const inProgress = rows.filter(r => r.status === 'in-progress').length
  const completed = rows.filter(r => r.status === 'completed').length
  const other = rows.filter(
    r => !['in-progress', 'completed'].includes(r.status)
  ).length
  const progressPercent = total > 0 ? (completed / total) * 100 : 0

  return { total, inProgress, completed, other, progressPercent }
}

export function getStatusLabel(status: string): string {
  return PILE_HOLE_STATUS_LABELS[status] ?? status
}

export function getStatusBadgeClass(status: string): string {
  return PILE_HOLE_STATUS_BADGE[status] ?? 'badge-secondary'
}

// Re-export for table cell formatting
export { formatPreboreValue }
